import type { Theme } from '@mui/material';

export const ANNOTATOR_PROJECTS_TAG = 'annotator-projects';

export const STATUS_ICON_COLOR_MAPPING = (theme: Theme) => {
  return {
    ref_std_review: theme.palette.warning.main,
    inProgress: theme.palette.info.main,
    completed: theme.palette.success.main,
  };
};
